export default __webpack_public_path__ + "static/media/arrowRightWhite.18f38724.svg";